class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

 
 
// this script is used to prevent the quantity of items in the cart from being changed
// it also prevents the quantity from being changed when the form is submitted
// it is used in the cart page
 

         document.addEventListener("DOMContentLoaded", () => {
          // Ensure quantity inputs are always set to 1
          const cartItems = document.querySelectorAll(".cart-item__quantity .quantity__input");
        
          cartItems.forEach((input) => {
            // Check if the quantity is greater than 1
            if (parseInt(input.value, 10) > 1) {
              // Update the input value
              input.value = 1;
              input.setAttribute("value", "1"); // Ensure attribute is also set
              input.setAttribute("data-cart-quantity", "1"); // Sync data attributes
        
              // Trigger an update to reflect the change in the cart
              const updateEvent = new Event("change", { bubbles: true });
              input.dispatchEvent(updateEvent);
            }
        
            // Make the input readonly to prevent further changes
            input.setAttribute("readonly", true);
            input.setAttribute("min", "1"); // Ensure minimum is 1
        
            // Disable increment and decrement buttons
            const minusButton = input.closest(".quantity").querySelector('button[name="minus"]');
            const plusButton = input.closest(".quantity").querySelector('button[name="plus"]');
        
            if (minusButton) {
              minusButton.setAttribute("disabled", true);
            }
            if (plusButton) {
              plusButton.setAttribute("disabled", true);
            }
          });
        
          // Optionally prevent direct form submission from changing quantity
          const cartForm = document.querySelector("form[action='/cart']");
          if (cartForm) {
            cartForm.addEventListener("submit", (e) => {
              cartItems.forEach((input) => {
                input.value = 1; // Ensure all quantities are reset to 1 before submission
              });
            });
          }
        });
 